import $ from 'jquery';
import React, {Component} from 'react';
import {connect} from 'react-redux';
import Moment from 'react-moment';
import limparUltimosHIstoricosUsuario from '../../../actions/usuario/limparUltimosHIstoricosUsuario';
import capitalizarTodasPrimeirasLetras from '../../../util/capitalizarTodasPrimeirasLetras';

export const Cabecalho = () => (
    <div className="lista-eventos titulo">
        <div className="row cabecalho-desktop" style={{fontWeight: 'bold'}}>
            <div className="col-12 col-sm-12 col-md">Data e Hora</div>
            <div className="col-12 col-sm-12 col-md">Histórico</div>
            <div className="col-12 col-sm-12 col-md">Usuario responsável</div>
            <div className="col-12 col-sm-12 col-md">Perfis Atuais</div>
            <div className="col-12 col-sm-12 col-md">Telefone</div>
            <div className="col-12 col-sm-12 col-md">Usuário Ativo</div>
            <div className="col-12 col-sm-12 col-md">Usuario Bloqueado</div>
        </div>
    </div>
);

export class ModalHistoricoUsuario extends Component {

    fecharModal() {
        $('#modalHistoricoUsuario')
            .modal('hide');
        $('#modalHistoricoUsuario')
            .hide();
        $('.modal-backdrop')
            .hide();
        this.props.limparUltimosHIstoricosUsuario();
    }

    exibirItinerarioBloqueado(historico) {
        // eslint-disable-next-line no-undef
        if (historico.usuarioEmpresa && _.isNil(historico.usuarioEmpresa.bloqueado)) {
            if (historico.usuarioEmpresa.bloqueado) {
                return <p>Sim</p>
            } else {
                return <p>Não</p>
            }
        }
        return '';
    }

    formatarRoles(usuarioRoles) {
        const perfis = usuarioRoles.split(',');
        return perfis.map(it => (<p key={it} style={{padding: '0px', margin: '0px'}}> {it} </p>));
    }

    exibirHistoricos() {
        if (this.props.historicos && this.props.historicos.length) {
            return this.props.historicos.map(historico => <div className="lista-eventos"
                                                               key={`${historico.id}-${historico.dataEvento}`}>
                <div className="row conteudo-desktop mb-3">
                    <div className="col-12 col-sm-12 col-md">
                        <Moment
                            format="DD/MM/YYYY HH:mm">{historico.dataEvento}</Moment>
                    </div>
                    <div className="col-12 col-sm-12 col-md">
                        <div id="evento" className="texto">
                            <p>{capitalizarTodasPrimeirasLetras(historico.tipoEvento)}</p>
                        </div>
                    </div>
                    <div className="col-12 col-sm-12 col-md">
                        <div id="evento" className="texto">
                            <p>{historico.responsavel && historico.responsavel.nome}</p>
                        </div>
                    </div>
                    <div className="col-12 col-sm-12 col-md">
                        <div id="evento" className="texto">
                            <div style={{overflowY: 'auto', overflowX: 'hidden', height: '38px'}}>
                                {historico.usuarioEmpresa != null ? this.formatarRoles(historico.usuarioEmpresa.usuarioRoles.replaceAll('ROLE_', '')) : null}
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-sm-12 col-md">
                        <div id="evento" className="texto">
                            {historico.usuario && historico.usuario.telefones ? historico.usuario.telefones : '-'}
                        </div>
                    </div>
                    <div className="col-12 col-sm-12 col-md">
                        <div id="evento" className="texto">
                            <p>{historico.usuarioEmpresa != null ? historico.usuarioEmpresa.ativo ? 'Sim' : 'Não' : null}</p>
                        </div>
                    </div>
                    <div className="col-12 col-sm-12 col-md">
                        <div id="evento" className="texto">
                            <p>{this.exibirItinerarioBloqueado(historico)}</p>
                        </div>
                    </div>
                </div>
            </div>)
        }
        return ''
    }

    render() {
        return (
            <div className="modal fade show" id='modalHistoricoUsuario' role='dialog'
                 aria-labelledby='modalHistoricoUsuario' aria-hidden='true' data-backdrop='static'>
                <div className={'modal-dialog modal-dialog-centered modal-xl'}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5>Histórico
                                Usuários {`${this.props.rotaSelecionada ? '- ' + this.props.rotaSelecionada.id : ''}`}</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <i className="material-icons" onClick={() => this.fecharModal()}>
                                    &#xe5cd;
                                </i>
                            </button>
                        </div>
                        <div className="modal-body">
                            <Cabecalho/>
                            {this.exibirHistoricos()}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export const mapStateToProps = (state) => {
    return {
        rotaSelecionada: state.rotaSelecionada,
        empresaSelecionada: state.empresaSelecionada,
        historicoUsuarioDtos: state.ultimosHistoricosUsuario.historicoUsuarioDtos,
        historicoUsuarioEmpresaDtos: state.ultimosHistoricosUsuario.historicoUsuarioEmpresaDtos,
        historicos: state.ultimosHistoricosUsuario.historicoUsuarioGeralDto
    }
};

export default connect(mapStateToProps, {
    limparUltimosHIstoricosUsuario
})(ModalHistoricoUsuario)